const searchFocus = {

    searchWrap: document.getElementById('jsOpenSearch') as HTMLElement, 
    searchInput: document.getElementById('searchInput') as HTMLElement,


    init() {
        this.setFocus();
    },


    setFocus(){
        this.searchWrap.addEventListener('click', (e) => {
            e.preventDefault();
            setTimeout(() => {
                this.searchInput.focus();
            }, 500);
            
        
        })
    }
}

export default searchFocus;